
import {
    SET_AUTH,
    SET_USER_LOADING,
    SET_ACCOUNT_ERROR,
    SET_ACCOUNT_LOGO_ANIMATION_DONE,
    SET_UPDATE_ACCOUNT,
    SET_USER_UPDATING,
    CLEAR_AUTH
} from '@/store/mutations.type.js'

export default {
    // For logo animation
    [SET_ACCOUNT_LOGO_ANIMATION_DONE] (state, flag) {
        state.accountLogoAnimationDone = flag
    },

    // For user loading flag
    [SET_USER_LOADING](state, flag) {
        state.userLoading = flag
    },

    // Auth mutation
    [SET_AUTH](state, user) {
        state.user = user
        state.isLogedIn = true
        state.accountError = null
    },

    // Loging out or clearing main user
    [CLEAR_AUTH](state) {
        state.user = null
        state.isLogedIn = false
        state.accountError = null
    },

    // Validation errors on accounts
    [SET_ACCOUNT_ERROR](state, errors) {
        state.accountError = errors
    },

    // User updating
    [SET_USER_UPDATING](state, flag) {
        state.userUpdating = flag
    },

    // Update user account
    [SET_UPDATE_ACCOUNT](state, payload) {
        Object.assign(state.user, payload.value)
    }
}
